import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import {
  FETCH_PUBLISHERS_LIST, FETCHED_PUBLISHERS_LIST,
  FETCH_CATEGORIES_LIST, FETCHED_CATEGORIES_LIST,
  FETCH_KEYWORDS_LIST, FETCHED_KEYWORDS_LIST,
  FETCH_BRANDS_LIST, FETCHED_BRANDS_LIST,
 } from 'components/Global/Filters/actions.js';
import { brands, keywords, publishers, categories, content } from 'api';

export const FETCH_SEARCH_FEED = 'FETCH_SEARCH_FEED';
export const FETCHED_SEARCH_FEED = 'FETCHED_SEARCH_FEED';
export const SET_SEARCH_FEED_FILTER = 'SET_SEARCH_FEED_FILTER';

// competitors
export const fetchSearchKeywords = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: filters => keywords.getKeywordsList(filters),
});

export const fetchSearchCategories = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().CategoriesList.categoriesList,
  fetchingActionType: FETCH_CATEGORIES_LIST,
  fetchedActionType: FETCHED_CATEGORIES_LIST,
  apiCall: filters => categories.getCategoriesList(filters),
});

export const fetchSearchBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().BrandsList.brandsList,
  fetchingActionType: FETCH_BRANDS_LIST,
  fetchedActionType: FETCHED_BRANDS_LIST,
  apiCall: filters => brands.getBrandsList(filters),
});

export const fetchSearchPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PublishersList.publishersList,
  fetchingActionType: FETCH_PUBLISHERS_LIST,
  fetchedActionType: FETCHED_PUBLISHERS_LIST,
  apiCall: filters => publishers.getPublishersList(filters),
});

export const fetchSearchFeed = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().SearchFeed.contentList,
  fetchingActionType: FETCH_SEARCH_FEED,
  fetchedActionType: FETCHED_SEARCH_FEED,
  apiCall: filters => content.getContentList(filters),
});

export const preFetchSearchPage = () => (dispatch) => Promise.all([
  dispatch(fetchSearchKeywords(true)),
  dispatch(fetchSearchCategories(true)),
  dispatch(fetchSearchBrands(true)),
  dispatch(fetchSearchPublishers(true)),
  dispatch(fetchSearchFeed(true)),
]);

